import { create } from "zustand";

// custom persist implementation (...yes)
export const useStore = create((set) => ({
  token: localStorage.getItem("token"),
  setToken: (token) => localStorage.setItem("token", token) ?? set({ token }),

  anime: null,
  setAnime: (anime) => set({ anime }),

  animes: [],
  setAnimes: (animes) => set({ animes }),

  viewHiddenAnimes: localStorage.getItem("viewHiddenAnimes") === "true",
  setViewHiddenAnimes: (visibility) => localStorage.setItem("viewHiddenAnimes", "true") ?? set({ viewHiddenAnimes: visibility }),

  broadcast: null,
  setBroadcast: (broadcast) => set({ broadcast }),

  broadcasts: [],
  setBroadcasts: (broadcasts) => set({ broadcasts }),

  viewHiddenBroadcasts: localStorage.getItem("viewHiddenBroadcasts") === "true",
  setViewHiddenBroadcasts: (visibility) => localStorage.setItem("viewHiddenBroadcasts", "true") ?? set({ viewHiddenBroadcasts: visibility }),

  announcement: null,
  announceUntil: null,
  setAnnouncement: (announcement) => set(announcement === null ? { announcement: null, announceUntil: null } : { announcement: announcement.text, announceUntil: announcement.until })
}));
